// How a page's name is SHOWN. "/" is the home page's path, which means nothing to most people ("what is /?"), so wherever a page is named for a person it reads "/ (Home page)". The stored and
// compared name stays "/" everywhere: this is only for display. One constant, so the wording is one edit.
export const HOME_PAGE_NOTE = "(Home page)";

export const pageLabel = (name: string): string => (name === "/" ? `/ ${HOME_PAGE_NOTE}` : name);
